import type { AuthenticationApi } from './authentication-owner';

// Ordinary commerce operations need usable credentials, not an SSO preflight.
export async function ensureIdentitySession(forceUpdate = false): Promise<void> {
  const authentication = globalThis.ikea.mvAgent.authentication as AuthenticationApi;
  if (forceUpdate) await authentication.isLoggedIn(true);
  await authentication.getTokens();
}

// Wait once for initial SSO, so commerce does not first load the guest's data.
// A failed SSO check must still allow existing credentials or a guest session.
export function createIdentitySessionInitializer(): () => Promise<void> {
  let initialization: Promise<void> | undefined;
  return () =>
    (initialization ??= (async () => {
      const authentication = globalThis.ikea.mvAgent.authentication as AuthenticationApi;
      if (authentication.meta.isCiamEnabled) {
        try {
          await authentication.isLoggedIn();
        } catch (error) {
          console.error('Failed to verify initial identity', error);
        }
      } else {
        // ICAPS must reconcile stale login cookies with the server once at startup.
        await authentication.isLoggedIn(true);
      }
      await ensureIdentitySession();
    })().catch((error: unknown) => {
      initialization = undefined;
      throw error;
    }));
}
